import { ErrorHandler, inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@application/config';
import { ErrorStore } from '../error.store';
import { recoverFromChunkLoadError } from './chunk-load-error';
import { reportRuntimeErrorToSentry } from './sentry-error-reporter';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService implements ErrorHandler {
  private readonly errorStore = inject(ErrorStore);
  private readonly appConfig = inject(APP_CONFIG);

  handleError(error: Error) {
    console.error(error);

    // A failed lazy-chunk fetch usually means the deploy changed under a stale
    // tab. Reload once to pick up the new release instead of surfacing a broken
    // screen. When it triggers, the page reloads so no further handling runs.
    if (recoverFromChunkLoadError(error)) {
      return;
    }

    this.errorStore.setJavascriptError(error);

    // Report runtime errors to Sentry only in production. The reporter throttles
    // by error signature and caps per session so noisy errors don't flood Sentry.
    if (this.appConfig.environment === 'prod') {
      reportRuntimeErrorToSentry(error);
    }
  }
}
